import { cva } from 'class-variance-authority';

import { cn } from 'src/lib/utils';

import type { VariantProps } from 'class-variance-authority';

const spinnerVariants = cva(
  `animate-spin rounded-full border-3 border-silver-darken-10 border-t-silver-darken-70`,
  {
    variants: {
      size: {
        sm: 'size-16',
        md: 'size-24',
        lg: 'size-32',
      },
    },
    defaultVariants: {
      size: 'lg',
    },
  },
);

export const Spinner = ({
  size,
  className,
}: VariantProps<typeof spinnerVariants> & React.ComponentProps<'svg'>) => {
  return (
    <div
      aria-label="Loading"
      className={cn(spinnerVariants({ size }), className)}
      role="status"
    />
  );
};
